import React from 'react';
import { Check } from 'phosphor-react';

interface ProgressStepBarProps {
  steps: string[];
  currentStep: number;
  disabledSteps?: number[];
}

export const ProgressStepBar: React.FC<ProgressStepBarProps> = ({
  steps,
  currentStep,
  disabledSteps = [],
}) => {
  return (
    <ol className="flex w-full items-start">
      {steps.map((label, idx) => {
        const isLast = idx === steps.length - 1;
        const isDisabled = disabledSteps.includes(idx);
        const status = idx === currentStep ? 'active' : idx < currentStep ? 'complete' : 'upcoming';

        const circleBase =
          'flex items-center justify-center w-7 h-7 rounded-full font-bold relative z-10 transition-all duration-300 flex-shrink-0';

        const circleStyles = isDisabled
          ? 'bg-gray-200 text-gray-400'
          : status === 'complete'
          ? 'PRIMARY_500-BG text-white'
          : status === 'active'
          ? 'bg-white PRIMARY_500-CLR border-2 PRIMARY_500-BORDER shadow-sm'
          : 'bg-white text-gray-300 border-2 border-gray-200';

        const lineColor = status === 'complete' ? 'PRIMARY_500-BG' : 'bg-gray-200';

        return (
          <li key={idx} className="flex-1 flex flex-col items-center relative text-center">
            {/* Connector line */}
            {!isLast && (
              <div
                className={`absolute top-3.5 left-1/2 w-full h-[2px] transition-all duration-500 ${lineColor}`}
              />
            )}

            {/* Circle */}
            <div className="relative">
              {status === 'active' && (
                <span className="absolute inset-0 rounded-full PRIMARY_500-BG opacity-20 animate-ping" />
              )}
              <div className={`${circleBase} ${circleStyles}`}>
                {status === 'complete' ? (
                  <Check size={13} weight="bold" color="white" />
                ) : (
                  <span className="text-xs">{idx + 1}</span>
                )}
              </div>
            </div>

            {/* Label */}
            <span
              className={`mt-2 mx-0.5 text-[10px] md:text-xs leading-tight hidden md:block transition-colors duration-300 ${
                status === 'active'
                  ? 'font-semibold PRIMARY_500-CLR'
                  : status === 'complete'
                  ? 'font-medium GREY_700-CLR'
                  : 'GREY_400-CLR'
              }`}>
              {label}
            </span>
          </li>
        );
      })}
    </ol>
  );
};
